import React, { createContext, useContext, useEffect, useRef, useSyncExternalStore } from 'react';

const ScrollContext = createContext({ isScrolled: false, scrollY: 0 });

// Lightweight scroll store — updates a ref on rAF, only re-renders subscribers
// when the meaningful value (isScrolled) actually changes.
let scrollSnapshot = { isScrolled: false, scrollY: 0 };
const listeners = new Set();
function subscribe(cb) { listeners.add(cb); return () => listeners.delete(cb); }
function getSnapshot() { return scrollSnapshot; }

if (typeof window !== 'undefined') {
    let ticking = false;
    window.addEventListener('scroll', () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => {
            const y = window.scrollY;
            const isScrolled = y > 30;
            // Only notify React when isScrolled flips — not on every pixel
            if (isScrolled !== scrollSnapshot.isScrolled) {
                scrollSnapshot = { isScrolled, scrollY: y };
                listeners.forEach(cb => cb());
            } else {
                scrollSnapshot = { isScrolled, scrollY: y };
            }
            ticking = false;
        });
    }, { passive: true });
}

export const ScrollProvider = ({ children }) => {
    const value = useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
    return (
        <ScrollContext.Provider value={value}>
            {children}
        </ScrollContext.Provider>
    );
};

// Custom hook to use the scroll context
export const useScroll = () => useContext(ScrollContext);
